<template>
	<div class="ProgrammeExternalServices">
		<strong
			v-skeleton="{
				loading,
				sizes: {
					Small: { width: '7.433rem', height: '1.25rem' },
					Large: { width: '80%', height: '1.25rem' },
					ExtraLarge: { width: '7.433rem', height: '1.25rem' },
				},
				margins: {
					Small: '0.5rem 0',
				},
			}"
			class="Skeleton"
		>
			<div v-if="isMasters">
				<div
					class="BestFitOverview"
					:data-study-id="programmeId"
					data-widget-type="omni_search_button_icon"
					data-widget-location="sblp_search_study_card"
					data-empty-text="Check Your Fit"
				></div>
			</div>
		</strong>
		<strong
			v-skeleton="{
				loading,
				sizes: {
					Small: { width: '1.25rem', height: '1.25rem' },
				}
			}"
			class="Skeleton"
		>
			<div>
				<div
					class="WishlistButton"
					:data-study-id="programmeId"
					data-button-type="omni_search_icon_only"
				></div>
			</div>
		</strong>
	</div>

</template>

<script setup lang="ts">
const props = defineProps({
	programmeId: {
		type: String,
		required: true,
	},
	isMasters: {
		type: Boolean,
		required: true,
	},
	loading: {
		type: Boolean,
		default: false,
	},
});
</script>

<style scoped lang="scss">
.ProgrammeExternalServices {
	position: relative;
	display: flex;
	justify-content: space-between;
	align-items: center;
	width: 100%;

	@include Breakpoint(Large, ExtraLarge) {
		gap: 0.5rem;
		justify-content: flex-end;
		top: -0.5rem;
		max-width: 10rem;
	}
}
</style>